import ApprovalTermsConfig from './approval_terms_config';
import CommentBodyConfig from './comment_body_config';
import CompactConfig from './compact_config';
import ContractEditorConfig from './contract_editor_config';
import DesignRationaleConfig from './design_rationale_config';
import DesignerNotesConfig from './designer_notes_config';
import BillableNotesConfig from './billable_notes_config';
import ItemDescriptionConfig from './item_description_config';
import MessageTextConfig from './message_text_config';
import TaskNotesConfig from './task_notes_config';
import TextProcessorConfig from './text_processor_config';

export default class Config {
  static for(variant, options = {}) {
    switch (variant) {
      case 'comment_body':
        return new CommentBodyConfig();
      case 'compact':
        return new CompactConfig();
      case 'contract':
        return new ContractEditorConfig();
      case 'design_rationale':
        return new DesignRationaleConfig(options);
      case 'designer_notes':
        return new DesignerNotesConfig();
      case 'item_description':
        return new ItemDescriptionConfig();
      case 'invoice_notes':
      case 'purchase_order_notes':
      case 'quote_notes':
      case 'retainer_notes':
      case 'spec_sheet_notes':
        return new BillableNotesConfig();
      case 'message_text':
        return new MessageTextConfig();
      case 'quote_terms':
        return new ApprovalTermsConfig();
      case 'standard':
        return new TextProcessorConfig();
      case 'task_notes':
        return new TaskNotesConfig();
      default:
        return new TextProcessorConfig(); // This will change in next PR
    }
  }
}
